import React from "react";
import { Helmet } from "react-helmet-async";
import { Route, Routes } from "react-router-dom";
import Layout from "../../../components/Layout/layout";
import { HeaderType } from "../../../components/Layout/header";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";
import ChatSessionPage from "../../../components/chatSession";

const ChatSessionContainer = () => (
  <ProtectedRoute>
    <main>
      <Helmet title="Chat" />
      <Layout headerType={HeaderType.superadmin}>
        <Routes>
          <Route path="" element={<ChatSessionPage />} />
          <Route path=":sessionId" element={<ChatSessionPage />} />
        </Routes>
      </Layout>
    </main>
  </ProtectedRoute>
);

export default ChatSessionContainer;
